/**
 * @ngdoc Directive
 * @name vrmEvCarCharger
 * @example
 *
 * <vrmEvCarCharger type="out" attrs={object} />
 *
 */

(function() {
     'use strict';

     angular.module('vrm.components')
         .directive('vrmEvCarCharger', vrmEvCarCharger);

     /* @ngInject */
     function vrmEvCarCharger() {

         return {
             restrict: 'E',
             scope: {
                 type: '<',
                 attrs: '<',
             },
             transclude: true,
             template: require('@/angular/modules/vrm-components/car-charger/car-charger.template.html'),
         };

     }
 })();
